module.exports = __webpack_public_path__ + "static/media/mainLogo.e14e0e33.png";